import api from '@api/Api';

export default {

    getUnsubGroup(id) {
        return api().get(`/unsub-groups/${id}`);
    },

    createUnsubGroup(params) {
        return api().post(`/unsub-groups`, params);
    },

    updateUnsubGroup(id, params) {
        return api().put(`/unsub-groups/${id}`, params);
    },

    deleteUnsubGroup(id) {
        return api().delete(`/unsub-groups/${id}`);
    },

    getMembers(id) {
        return api().get(`/unsub-groups/${id}/members`);
    },

}
